// extracted by mini-css-extract-plugin
module.exports = {"errorMsg":"_1sZCa__errorMsg","errorMsgReason":"xU4cd__errorMsgReason","msTeamsConnecting":"_1uY86__msTeamsConnecting"};